import React, { useEffect, useRef } from 'react';

/**
 * Section header with title, count, and a tri-state "select all in section" checkbox.
 * Tri-state is derived on every render from `selectedIds` + `rows`.
 *   - allSelected -> checked
 *   - someSelected -> indeterminate
 *   - noneSelected -> unchecked
 *
 * Native checkboxes do not accept `indeterminate` as a JSX attribute, so we set
 * it imperatively via a ref after each render.
 */
export default function SectionHeader({
  icon,
  title,
  rows,
  selectedIds,
  onToggleAll,
  titleClassName = 'text-locate2-dark-blue',
}) {
  const checkboxRef = useRef(null);
  const total = rows.length;
  const selectedCount = rows.reduce(
    (n, r) => (selectedIds.has(r.id) ? n + 1 : n),
    0
  );
  const allSelected = total > 0 && selectedCount === total;
  const someSelected = selectedCount > 0 && selectedCount < total;

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  return (
    <div className="flex items-center gap-2 mb-3">
      <input
        ref={checkboxRef}
        type="checkbox"
        checked={allSelected}
        onChange={() => onToggleAll(!allSelected)}
        aria-label={`Select all ${title}`}
        className="w-4 h-4 rounded accent-locate2-primary cursor-pointer"
      />
      {icon}
      <h2 className={`text-lg font-semibold ${titleClassName}`}>
        {title} ({total})
      </h2>
    </div>
  );
}
